






import Vue from 'vue';

export default Vue.extend({
  name: 'App',
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue